import { Colors } from '@/constants/colors';

type PumpModeKey =
  | 'PSPM_MANUAL_CONTROL'
  | 'PSPM_SCHEDULE_CONTROL'
  | 'PSPM_SPA_CONTROL'
  | 'PSPM_FILTER_SOLAR_CONTROL'
  | 'PSPM_POOL_HEATER_CONTROL'
  | 'PSPM_SPA_HEATER_CONTROL'
  | 'PSPM_SHARED_HEATER_CONTROL'
  | 'PSPM_CLEANER_CONTROL';

type PumpMode = {
  key: PumpModeKey;
  priority: number;
  bitIndex: number;
  title: string;
  badgeTitle: string;
  color: string;
};

const PUMP_MODES: PumpMode[] = [
  {
    key: 'PSPM_MANUAL_CONTROL',
    priority: 0,
    bitIndex: 0,
    title: 'Manual',
    badgeTitle: 'Manual Speed Priority',
    color: Colors.TEAL_200,
  },
  {
    key: 'PSPM_SCHEDULE_CONTROL',
    priority: 0,
    bitIndex: 1,
    title: 'Schedule',
    badgeTitle: 'Schedule Speed Priority',
    color: Colors.ALGAE_GREEN,
  },
  {
    key: 'PSPM_SPA_CONTROL',
    priority: 4,
    bitIndex: 2,
    title: 'Spa Mode',
    badgeTitle: 'Spa Speed Priority',
    color: Colors.ORANGE,
  },
  {
    key: 'PSPM_FILTER_SOLAR_CONTROL',
    priority: 2,
    bitIndex: 3,
    title: 'Solar Heater',
    badgeTitle: 'Solar Heater Speed Priority',
    color: Colors.BUS_YELLOW,
  },
  {
    key: 'PSPM_POOL_HEATER_CONTROL',
    priority: 1,
    bitIndex: 4,
    title: 'Pool Heater',
    badgeTitle: 'Pool Heater Speed Priority',
    color: Colors.BUS_YELLOW,
  },
  {
    key: 'PSPM_SPA_HEATER_CONTROL',
    priority: 1,
    bitIndex: 5,
    title: 'Spa Heater',
    badgeTitle: 'Spa Heater Speed Priority',
    color: Colors.BUS_YELLOW,
  },
  {
    key: 'PSPM_SHARED_HEATER_CONTROL',
    priority: 1,
    bitIndex: 6,
    title: 'Shared Heater',
    badgeTitle: 'Shared Heater Speed Priority',
    color: Colors.BUS_YELLOW,
  },
  {
    key: 'PSPM_CLEANER_CONTROL',
    priority: 3,
    bitIndex: 7,
    title: 'Cleaner',
    badgeTitle: 'Cleaner Speed Priority',
    color: Colors.RED,
  },
];

const hasBit = (speedPriority: number, bitIndex: number): boolean => {
  return (speedPriority & (1 << bitIndex)) !== 0;
};

export const getHighestPriorityPumpMode = (speedPriority?: number | null): PumpMode | null => {
  if (!speedPriority || speedPriority <= 0) return null;

  const active = PUMP_MODES.filter((m) => hasBit(speedPriority, m.bitIndex)).sort(
    (a, b) => b.priority - a.priority
  );
  const top = active[0] || null;
  if (!top) return null;
  if (top.key === 'PSPM_MANUAL_CONTROL' || top.key === 'PSPM_SCHEDULE_CONTROL') return null;
  return top;
};

